import { Box } from '@chakra-ui/react';
import React from 'react';

interface AnimatedIconProps {
  icon: React.ReactNode;
  animation: 'pulse' | 'scaleIn';
  size?: number;
}

export const AnimatedIcon: React.FC<AnimatedIconProps> = ({ icon, animation, size = 48 }) => {
  const animations = {
    pulse: {
      '@keyframes pulse': {
        '0%, 100%': {
          transform: 'scale(1)',
          opacity: 1,
        },
        '50%': {
          transform: 'scale(1.1)',
          opacity: 0.8,
        },
      },
      animation: 'pulse 1.5s ease-in-out infinite',
    },
    scaleIn: {
      '@keyframes scaleIn': {
        from: {
          transform: 'scale(0)',
          opacity: 0,
        },
        to: {
          transform: 'scale(1)',
          opacity: 1,
        },
      },
      animation: 'scaleIn 0.5s ease-out',
    },
  };

  return (
    <Box
      w={`${size}px`}
      h={`${size}px`}
      display="flex"
      alignItems="center"
      justifyContent="center"
      css={animations[animation]}
    >
      {icon}
    </Box>
  );
};
